module.exports = __webpack_public_path__ + "files/1b3742939122fdb7574a9fdfc1cbba2e.png";